function MenuInteremedioAcerca() {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.innerContainer}>
        <button style={styles.boton} onClick={() => scrollToSection("historia")}>Historia</button>
        <button style={styles.boton} onClick={() => scrollToSection("mision")}>Misión</button>
        <button style={styles.boton} onClick={() => scrollToSection("horarios")}>Sedes</button>
        <button style={styles.boton} onClick={() => scrollToSection("mision")}>Símbolos</button>
        <button style={styles.boton} onClick={() => scrollToSection("exalumnos")}>ExAlumnos</button>
        <button style={styles.boton} onClick={() => scrollToSection("horarios")}>Horarios</button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    overflowX: 'auto',
    width: '100%',
    backgroundColor: 'white',
  },
  innerContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '1rem',
    padding: '0.5rem',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  boton: {
    padding: '0.6rem 1.2rem',
    backgroundColor: 'transparent',
    color: 'green',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap',
  },
};

export default MenuInteremedioAcerca;
